import { createSlice } from '@reduxjs/toolkit';

const getDevicesSlice = createSlice({
  name: 'getDevices',
  initialState: {
    loading: false,
    devices: null,
    success: false,
    error: null,
  },
  reducers: {
    getDevicesRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getDevicesSuccess(state, action) {
      state.loading = false;
      state.devices = action.payload;
      state.success = true;
    },
    getDevicesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const { getDevicesRequest, getDevicesSuccess, getDevicesFailure } = getDevicesSlice.actions;
export default getDevicesSlice.reducer;
